// opervex-frontend/src/routes/accountingRoutes.js

import Branch from "../pages/Accounting/Branch";
import City from "../pages/Accounting/City";
import FiscalPeriod from "../pages/Accounting/FiscalPeriod";
import Customers from "../pages/Accounting/Customers";
import Vendors from "../pages/Accounting/Vendors";
import CostCenters from "../pages/Accounting/CostCenters";

const accountingRoutes = [
  // Branch/Company
  { path: "Accounting/Branch", private: true, component: <Branch />, role: "BRANCH" },
  { path: "Accounting/Branch/:id", private: true, component: <Branch />, role: "BRANCH" },

  // City
  { path: "Accounting/City", private: true, component: <City />, role: "CITY" },
  { path: "Accounting/City/:id", private: true, component: <City />, role: "CITY" },

  // Fiscal Period
  { path: "Accounting/FiscalPeriod", private: true, component: <FiscalPeriod />, role: "FISCAL_PERIOD" },
  { path: "Accounting/FiscalPeriod/:id", private: true, component: <FiscalPeriod />, role: "FISCAL_PERIOD" },

  // Customers
  { path: "Accounting/Customers", private: true, component: <Customers />, role: "CUSTOMERS" },
  { path: "Accounting/Customers/:id", private: true, component: <Customers />, role: "CUSTOMERS" },

  // Vendors
  { path: "Accounting/Vendors", private: true, component: <Vendors />, role: "VENDORS" },
  { path: "Accounting/Vendors/:id", private: true, component: <Vendors />, role: "VENDORS" },

  { path: "Accounting/CostCenters", private: true, component: <CostCenters />, role: "COST_CENTER" },
  { path: "Accounting/CostCenters/:id", private: true, component: <CostCenters />, role: "COST_CENTER" },
];

export default accountingRoutes;
